//File Path
export const JSON_FILE_DATA = '/portfolio_data.json';
export const JSON_ICON_DATA = '/icon_data.json';